import * as React from "react";

import { RouteStore } from "bernie-core";
import { ClientWizardStateStore } from "src/stores/wizard/ClientWizardStateStore";

import { PackagesSubLobs } from "../typings";

import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { FlightTypeMenu } from "../../WizardFlightPWA/components/FlightTypeMenu";
import { UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";
import { Travelers } from "src/components/shared/Travelers/Travelers";
import { PreferredClassInput, ClassCodes } from "src/components/shared/PreferredClassInput/PreferredClassInput";
import { TravelersTriggerTypes, NoRehydratationValues } from "src/components/shared/TravelersField/typings";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

export type MenuFieldsProps = {
  currentSubLOB: string;
  routeStore: RouteStore;
  wizardState: ClientWizardStateStore;
  noRehydratationValues?: NoRehydratationValues;
  displayNewPackageFlightType: boolean;
  onFlightTypeUpdate: (FlightType: string) => void;
  setFlightType: () => string;
  showOneway: boolean;
  showMulticity: boolean;
  onSelectPreferredClassCode: (classCode: ClassCodes) => void;
  className?: string;
};

export const MenuFields: React.FC<MenuFieldsProps> = ({
  currentSubLOB,
  routeStore,
  wizardState,
  noRehydratationValues,
  displayNewPackageFlightType,
  onFlightTypeUpdate,
  setFlightType,
  showOneway,
  showMulticity,
  onSelectPreferredClassCode,
  className = "",
}) => {
  const { packageWizardState } = wizardState;
  const { config: packageConfig } = packageWizardState;

  const flightMenuColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12 };
  const travelersColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12 };
  const preferredClassColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12 };
  const isPackageContainingFlight = !packageWizardState.isPackageHotelCar();

  const flightTypeSelectorInPillExperimentName = "newFlightsinPill";

  return (
    <>
      <UitkLayoutFlex space="six" className={`packageSelectors ${className}`} wrap="wrap">
        {displayNewPackageFlightType && (
          <Experiment name={flightTypeSelectorInPillExperimentName}>
            <ExperimentControl>
              <UitkLayoutFlexItem className="packageSelector">
                <FlightTypeMenu
                  onFlightTypeUpdate={onFlightTypeUpdate}
                  setFlightType={setFlightType}
                  showOneway={showOneway}
                  showMulticity={showMulticity}
                  colSpan={flightMenuColSpan}
                />
              </UitkLayoutFlexItem>
            </ExperimentControl>
            <ExperimentVariant bucket={1} />
          </Experiment>
        )}

        {currentSubLOB === PackagesSubLobs.FLIGHTS_HOTEL && (
          <UitkLayoutFlexItem className="packageSelector">
            <Travelers
              tripLobType={routeStore.queryParams.pwaSubLOB}
              lobState={packageWizardState}
              colSpan={travelersColSpan}
              noRehydratationValues={noRehydratationValues}
              triggerType={TravelersTriggerTypes.LINK_BUTTON}
            />
          </UitkLayoutFlexItem>
        )}

        {currentSubLOB === PackagesSubLobs.FLIGHTS_CAR && (
          <UitkLayoutFlexItem className="packageSelector">
            <Travelers
              tripLobType={routeStore.queryParams.pwaSubLOB}
              lobState={packageWizardState}
              colSpan={travelersColSpan}
              noRehydratationValues={{
                numOfTravelers: 1,
                name: "adultsPerRoom[1]",
              }}
              config={packageConfig.subLOB.flightCar.travelers}
              triggerType={TravelersTriggerTypes.LINK_BUTTON}
            />
          </UitkLayoutFlexItem>
        )}

        {currentSubLOB === PackagesSubLobs.FLIGHTS_HOTEL_CAR && (
          <UitkLayoutFlexItem className="packageSelector">
            <Travelers
              tripLobType={routeStore.queryParams.pwaSubLOB}
              lobState={packageWizardState}
              colSpan={travelersColSpan}
              noRehydratationValues={noRehydratationValues}
              triggerType={TravelersTriggerTypes.LINK_BUTTON}
            />
          </UitkLayoutFlexItem>
        )}

        {currentSubLOB === PackagesSubLobs.HOTEL_CAR && (
          <UitkLayoutFlexItem className="packageSelector">
            <Travelers
              tripLobType={routeStore.queryParams.pwaSubLOB}
              lobState={packageWizardState}
              config={packageConfig.subLOB.hotelCar.travelers}
              colSpan={travelersColSpan}
              noRehydratationValues={noRehydratationValues}
              triggerType={TravelersTriggerTypes.LINK_BUTTON}
            />
          </UitkLayoutFlexItem>
        )}

        {packageConfig.showAllSubLOB && isPackageContainingFlight && (
          <UitkLayoutFlexItem className="packageSelector">
            <PreferredClassInput
              colSpan={preferredClassColSpan}
              onSelectPreferredClassCode={onSelectPreferredClassCode}
              wizardState={wizardState}
            />
          </UitkLayoutFlexItem>
        )}
      </UitkLayoutFlex>
    </>
  );
};
